import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './HomePage.css';

export default function HomePage() {
  const { currentUser, loading } = useAuth();

  // If already signed in, treat home as a simple gateway to the app.
  if (!loading && currentUser) return <Navigate to="/rrm" replace />;

  return (
    <div className="home">
      <div className="home-card">
        <div className="home-brand">RRM</div>
        <h1 className="home-title">RRMonitor</h1>
        <p className="home-subtitle">Log in to access the RRM comparison dashboard.</p>

        <div className="home-actions">
          <Link className="home-btn home-btn-primary" to="/signin">
            Log in
          </Link>
          <Link className="home-btn home-btn-secondary" to="/signup">
            Sign up
          </Link>
        </div>
      </div>
    </div>
  );
}


